/* eslint-disable no-unused-vars */
import classNames from "classnames";
import React, {
  InputHTMLAttributes,
  useCallback,
  useRef,
  useState,
} from "react";

// styles
import styles from "./styles.module.scss";

export enum SearchVariant {
  DEFAULT = "DEFAULT",
  SMALL = "SMALL",
}

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  handleChange: (e: string | number) => void;
  handleSearchClick: () => void;
  variant?: SearchVariant;
}

const SearchTextInput: React.FC<Props> = ({
  handleChange,
  variant = SearchVariant.DEFAULT,
  ...props
}: Props) => {
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [focused, setFocused] = useState<boolean>(false);

  const onChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>): void => {
      handleChange(e?.target?.value);
    },
    [handleChange]
  );

  return (
    <div onClick={() => inputRef?.current?.focus} className={styles.container}>
      <div className={styles.image_container}>
        <img src="assets/images/svg/search.svg" />
      </div>
      {variant === SearchVariant.DEFAULT && (
        <input
          ref={inputRef}
          className={classNames(styles.searchInput, "hint", "g600")}
          onChange={onChange}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          dir="rtl"
          {...props}
        />
      )}

      <div onClick={() => handleChange("")} className={styles.image_container}>
        {inputRef?.current?.value && (
          <img src="assets/images/svg/crossAlternate.svg" />
        )}
      </div>
    </div>
  );
};

export default React.memo(SearchTextInput);
